import React from "react";
import { useSelector } from "react-redux";
import { CardPrices } from "../../reusableUI/v2UI/CardsPrices";

export const BoxTotals = ({ totals }) => {
  const {
    local_separacion_miles: separacion_miles,
    local_separacion_decimales: separacion_decimales,
    local_simbolo: simbolo,
  } = useSelector((state) => state.general.info);
  const { total_gastado = 0, total_pagado = 0, total_por_pagar = 0 } = totals;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 lg:grid-cols-3 mt-3">
      <CardPrices
        title="TOTAL GASTADO"
        total={total_gastado}
        percent={0}
        label="Monto total"
        bgColor="bg-orange-600"
        textColor="text-orange-600"
        formatMoney={{
          thousandSeparator: separacion_miles || ",",
          decimalSeparator: separacion_decimales || ".",
          prefix: simbolo || "S/",
        }}
        hasProgress={false}
      />

      <CardPrices
        title="PAGADO"
        total={total_pagado}
        percent={
          total_pagado
            ? (parseFloat(total_pagado) / parseFloat(total_gastado)) * 100
            : 0
        }
        label="de lo gastado"
        bgColor="bg-green-600"
        textColor="text-green-600"
        formatMoney={{
          thousandSeparator: separacion_miles || ",",
          decimalSeparator: separacion_decimales || ".",
          prefix: simbolo || "S/",
        }}
      />

      <CardPrices
        title="POR PAGAR"
        total={total_por_pagar}
        percent={
          total_por_pagar
            ? (parseFloat(total_por_pagar) / parseFloat(total_gastado)) * 100
            : 0
        }
        label="pendiente"
        bgColor="bg-red-600"
        textColor="text-red-600"
        formatMoney={{
          thousandSeparator: separacion_miles || ",",
          decimalSeparator: separacion_decimales || ".",
          prefix: simbolo || "S/",
        }}
      />
    </div>
  );
};
